import { Checkbox, Form, Input } from "antd";
import type React from "react";

const PreOpSection: React.FC = () => {
  return (
    <>
      <Form.Item label="Pre-op Orders" className="form-item checkbox-group-item">
        <div className="w-full">
          <Checkbox.Group style={{ width: "100%" }} className="checkbox-group">
            <div className="flex flex-wrap w-full gap-4">
              <div className="flex-1">
                <Form.Item name="wholeBlood" valuePropName="checked" noStyle>
                  <Checkbox className="checkbox-item">Whole Blood</Checkbox>
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item name="redCells" valuePropName="checked" noStyle>
                  <Checkbox className="checkbox-item">Red Cells</Checkbox>
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item name="platelets" valuePropName="checked" noStyle>
                  <Checkbox className="checkbox-item">Platelets</Checkbox>
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item name="othersPreOp" valuePropName="checked" noStyle>
                  <Checkbox className="checkbox-item">Others</Checkbox>
                </Form.Item>
              </div>
            </div>
          </Checkbox.Group>
        </div>
      </Form.Item>
      <div className="flex flex-wrap w-full gap-4 form-row counts-row">
        <div className="flex-1">
          <Form.Item label="Whole Blood (pkts)" name="wholeBloodCount" className="!mb-0">
            <Input className="form-input" />
          </Form.Item>
        </div>
        <div className="flex-1">
          <Form.Item label="Red Cells (pkts)" name="redCellsCount" className="!mb-0">
            <Input className="form-input" />
          </Form.Item>
        </div>
        <div className="flex-1">
          <Form.Item label="Platelets (pkts)" name="plateletsCount" className="!mb-0">
            <Input className="form-input" />
          </Form.Item>
        </div>
        <div className="flex-1">
          <Form.Item label="Others (pkts)" name="othersCount" className="!mb-0">
            <Input className="form-input" />
          </Form.Item>
        </div>
      </div>
    </>
  );
};

export default PreOpSection;
